export default __webpack_public_path__ + "static/ab-2d51f39502194cdb9753051a217eedc1.png";